import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["activeAlert", "limitReachedAlert"]
  static values = { limitCents: Number, placed: Boolean }

  // outlet API: called by live_wrapper via the auto-bid-status outlet
  update(currentBidAmountCents) {
    const relevant = this.placedValue && currentBidAmountCents > 0
    const active = relevant && this.limitCentsValue > currentBidAmountCents

    this.activeAlertTarget.classList.toggle(this.hiddenClass, !active)
    this.limitReachedAlertTarget.classList.toggle(this.hiddenClass, !(relevant && !active))
  }
}
